import React from 'react';

import QuickSwitcher from '../QuickSwitcher/QuickSwitcher';

import styles from './CompetitionCard.scss';

interface Props {
  competitionName: string;
}

const CompetitionCard: React.FC<Props> = ({ competitionName }) => (
  <div className={styles.wrapper}>
    <QuickSwitcher title={competitionName} />
  </div>
);

export { CompetitionCard };
